var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.25H17.25V12.75H16.5V15C16.5 15.1989 16.421 15.3897 16.2803 15.5303C16.1397 15.671 15.9489 15.75 15.75 15.75H2.25C2.05109 15.75 1.86032 15.671 1.71967 15.5303C1.57902 15.3897 1.5 15.1989 1.5 15V3C1.5 2.80109 1.57902 2.61032 1.71967 2.46967C1.86032 2.32902 2.05109 2.25 2.25 2.25H15.75C15.9489 2.25 16.1397 2.32902 16.2803 2.46967C16.421 2.61032 16.5 2.80109 16.5 3V5.25ZM15 12.75H10.5C9.50544 12.75 8.55161 12.3549 7.84835 11.6517C7.14509 10.9484 6.75 9.99456 6.75 9C6.75 8.00544 7.14509 7.05161 7.84835 6.34835C8.55161 5.64509 9.50544 5.25 10.5 5.25H15V3.75H3V14.25H15V12.75ZM15.75 11.25V6.75H10.5C9.90326 6.75 9.33097 6.98705 8.90901 7.40901C8.48705 7.83097 8.25 8.40326 8.25 9C8.25 9.59674 8.48705 10.169 8.90901 10.591C9.33097 11.0129 9.90326 11.25 10.5 11.25H15.75ZM10.5 8.25H12.75V9.75H10.5V8.25Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.015cab611c9df2039570cffa95908c75.svg";
export { ForwardRef as ReactComponent };